// import React from 'react';
// import {Link} from 'react-router-dom'
// import BlogSidebar from '../BlogSidebar'
// import VideoModal from '../../components/ModalVideo'

// import blogs from '../../api/blogs'
// // Import blog images
// import maakResidence2 from '../../images/projects/maak-residence-2.jpg';
// import aizelInterior1 from '../../images/projects/aizel-interior-1.jpg';
// import aizelTowerWarsan1 from '../../images/projects/aizel-tower-warsan-1.jpg';



// const BlogList = (props) => {

//     const ClickHandler = () =>{
//         window.scrollTo(10, 0);
//      }

//     return(
//         <section className="wpo-blog-pg-section section-padding">
//             <div className="container">
//                 <div className="row">
//                     <div className={`col col-lg-8 col-12 ${props.blRight}`}>
//                         <div className="wpo-blog-content">
//                             {blogs.slice(0,4).map((blog, bitem) => (
//                                 <div className={`post  ${blog.blClass}`}key={bitem}>
//                                     <div className="entry-media video-holder">
//                                         {blog.id === '1' && <img src={maakResidence2} alt=""/>}
//                                         {blog.id === '2' && <img src={aizelInterior1} alt=""/>}
//                                         {blog.id === '3' && <img src={aizelTowerWarsan1} alt=""/>}
//                                         <VideoModal/>
//                                     </div>
//                                     <div className="entry-meta">
//                                         <ul>
//                                             <li><i className="fi flaticon-user"></i> By <Link onClick={ClickHandler} to={`/blog-single/${blog.id}`}>{blog.authorTitle}</Link> </li>
//                                             {/* <li><i className="fi flaticon-comment-white-oval-bubble"></i> Comments {blog.comment} </li> */}
//                                             <li><i className="fi flaticon-calendar"></i> {blog.create_at}</li>
//                                         </ul>
//                                     </div>
//                                     <div className="entry-details">
//                                         <h3><Link onClick={ClickHandler} to={`/blog-single/${blog.id}`}>{blog.title}</Link></h3>
//                                         <p>{blog.description}</p>
//                                         <Link onClick={ClickHandler} to={`/blog-single/${blog.id}`} className="read-more">READ MORE...</Link>
//                                     </div>
//                                 </div>
//                             ))}

//                             <div className="pagination-wrapper pagination-wrapper-left">
//                                 <ul className="pg-pagination">
//                                     <li>
//                                         <Link to="/blog-left-sidebar" aria-label="Previous">
//                                             <i className="fi ti-angle-left"></i>
//                                         </Link>
//                                     </li>
//                                     <li className="active"><Link to="/blog-left-sidebar">1</Link></li>
//                                     <li><Link to="/blog-left-sidebar">2</Link></li>
//                                     <li><Link to="/blog-left-sidebar">3</Link></li>
//                                     <li>
//                                         <Link to="/blog-left-sidebar" aria-label="Next">
//                                             <i className="fi ti-angle-right"></i>
//                                         </Link>
//                                     </li>
//                                 </ul>
//                             </div>
//                         </div>
//                     </div>
//                     <BlogSidebar blLeft={props.blLeft}/>
//                 </div>
//             </div>
//         </section>

//      )
        
// }

// export default BlogList;


















// import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import BlogSidebar from '../BlogSidebar';
// import VideoModal from '../../components/ModalVideo';
// import { getBlogs } from '../../api/blogs';

// const BlogList = (props) => {
//   const [blogs, setBlogs] = useState([]);

//   const ClickHandler = () => {
//     window.scrollTo(10, 0);
//   };

//   // Function to format date from YYYY-MM-DD to DD MMM,YY
//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     const day = date.getDate().toString().padStart(2, '0');
//     const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
//     const year = date.getFullYear().toString().slice(-2);
//     return `${day} ${month},${year}`;
//   };

//   // Fetch blogs from API
//   useEffect(() => {
//     getBlogs().then((data) => setBlogs(data || []));
//   }, []);

//   return (
//     <section className="wpo-blog-pg-section section-padding">
//       <div className="container">
//         <div className="row">
//           <div className={`col col-lg-8 col-12 ${props.blRight}`}>
//             <div className="wpo-blog-content">
//               {blogs.map((blog) => (
//                 <div className="post" key={blog.id}>
//                   <div className="entry-media video-holder">
//                     <img src={blog.img} alt={blog.blogTitle} />
//                     <VideoModal />
//                   </div>

//                   <div className="entry-meta">
//                     <ul>
//                       <li>
//                         <i className="fi flaticon-user"></i> By{' '}
//                         <Link onClick={ClickHandler} to={`/blog-single/${blog.id}`}>
//                           {blog.authorTitle}
//                         </Link>
//                       </li>
//                       <li>
//                         <i className="fi flaticon-calendar"></i> {formatDate(blog.created_at)}
//                       </li>
//                     </ul>
//                   </div>

//                   <div className="entry-details">
//                     <h3>
//                       <Link onClick={ClickHandler} to={`/blog-single/${blog.id}`}>
//                         {blog.blogTitle}
//                       </Link>
//                     </h3>
//                     <p>{blog.description}</p>
//                     <Link
//                       onClick={ClickHandler}
//                       to={`/blog-single/${blog.id}`}
//                       className="read-more"
//                     >
//                       {blog.btn || 'Read More...'}
//                     </Link>
//                   </div>
//                 </div>
//               ))}

//               <div className="pagination-wrapper pagination-wrapper-left">
//                 <ul className="pg-pagination">
//                   <li>
//                     <Link to="/blog-left-sidebar" aria-label="Previous">
//                       <i className="fi ti-angle-left"></i>
//                     </Link>
//                   </li>
//                   <li className="active">
//                     <Link to="/blog-left-sidebar">1</Link>
//                   </li>
//                   <li>
//                     <Link to="/blog-left-sidebar">2</Link>
//                   </li>
//                   <li>
//                     <Link to="/blog-left-sidebar">3</Link>
//                   </li>
//                   <li>
//                     <Link to="/blog-left-sidebar" aria-label="Next">
//                       <i className="fi ti-angle-right"></i>
//                     </Link>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>

//           <BlogSidebar blLeft={props.blLeft} />
//         </div>
//       </div>
//     </section>
//   );
// };

// export default BlogList;












import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import BlogSidebar from '../BlogSidebar';
import VideoModal from '../../components/ModalVideo';
import { getBlogs } from '../../api/blogs';

const BlogList = (props) => {
  const [blogs, setBlogs] = useState([]);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  // Function to format date from YYYY-MM-DD to DD MMM,YY
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
    const year = date.getFullYear().toString().slice(-2);
    return `${day} ${month},${year}`;
  };

  // Fetch blogs from API
  useEffect(() => {
    getBlogs().then((data) => setBlogs(data || []));
  }, []);

  return (
    <section className="wpo-blog-pg-section section-padding">
      <div className="container">
        <div className="row">
          <div className={`col col-lg-8 col-12 ${props.blRight}`}>
            <div className="wpo-blog-content">
              {blogs.map((blog, bitem) => (
                <div className={`post ${blog.blClass || 'format-video'}`} key={bitem}>
                  <div className="entry-media video-holder">
                    <img src={blog.img} alt={blog.blogTitle} />
                    {bitem === blogs.length - 1 && <VideoModal />}
                  </div>

                  <div className="entry-meta">
                    <ul>
                      <li>
                        <i className="fi flaticon-user"></i> By{' '}
                        <Link onClick={ClickHandler} to={`/blog-single/${blog.id}`}>
                          {blog.authorTitle}
                        </Link>
                      </li>
                      <li>
                        <i className="fi flaticon-calendar"></i> {formatDate(blog.created_at)}
                      </li>
                    </ul>
                  </div>

                  <div className="entry-details">
                    <h3>
                      <Link onClick={ClickHandler} to={`/blog-single/${blog.id}`}>
                        {blog.blogTitle}
                      </Link>
                    </h3>
                    <p>{blog.description}</p>
                    <Link
                      onClick={ClickHandler}
                      to={`/blog-single/${blog.id}`}
                      className="read-more"
                    >
                      {blog.btn || 'Read More...'}
                    </Link>
                  </div>
                </div>
              ))}

              <div className="pagination-wrapper pagination-wrapper-left">
                <ul className="pg-pagination">
                  <li>
                    <Link to="/blog-left-sidebar" aria-label="Previous">
                      <i className="fi ti-angle-left"></i>
                    </Link>
                  </li>
                  <li className="active">
                    <Link to="/blog-left-sidebar">1</Link>
                  </li>
                  <li>
                    <Link to="/blog-left-sidebar">2</Link>
                  </li>
                  <li>
                    <Link to="/blog-left-sidebar">3</Link>
                  </li>
                  <li>
                    <Link to="/blog-left-sidebar" aria-label="Next">
                      <i className="fi ti-angle-right"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <BlogSidebar blLeft={props.blLeft} />
        </div>
      </div>
    </section>
  );
};

export default BlogList;